import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFixedStraightTubesHeatExchanger = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 40,
	viewBox: "0 0 100.0 40.0",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 0,
		width: 100,
		height: 40,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 8.0 0.0 L 8.0 40.0 M 92.0 0.0 L 92.0 40.0 M 8.0 5.0 L 92.0 5.0 M 8.0 10.0 L 92.0 10.0 M 8.0 15.0 L 92.0 15.0 M 8.0 20.0 L 92.0 20.0 M 8.0 25.0 L 92.0 25.0 M 8.0 30.0 L 92.0 30.0 M 8.0 35.0 L 92.0 35.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgFixedStraightTubesHeatExchanger;
